
import { Vue, Component, Prop } from "vue-property-decorator";
import api from "@/api";
import { axios, getConfigs, IRequestConfig } from "@/api/appService";

@Component({ name: "DataBox" })
export default class DataBox extends Vue {
  // props
  @Prop({ required: true })
  backgroundColor!: string;

  @Prop({ required: true })
  unit!: string;

  @Prop({ default: "get" })
  apiMethod!: string;

  @Prop({ default: "normal" })
  size!: string;

  @Prop({ required: true })
  apiUrl!: string;

  @Prop({ required: true })
  title!: string;

  @Prop()
  tooltip!:string;

  @Prop({ default: "year" })
  apiParamNameYear!: string;

  @Prop({ default: {} })
  apiParameters!: object;

  @Prop({ default: false })
  isHiddenYearParam!: boolean;

  // private members
  year: number = 2020;
  value: any = 0;
  loading: boolean = true;

  created() {
    this.year = new Date().getFullYear();
    this.fetchData();
  }

  get dataBoxClass() {
    const classes: any = {
      small: this.size === "small",
      normal: this.size === "normal"
    };
    classes[this.backgroundColor] = true;
    return classes;
  }

  nextYear() {
    this.year++;
    this.fetchData();
  }

  prevYear() {
    this.year--;
    this.fetchData();
  }

  async fetchData() {
    this.loading = true;
    await this.createApiRequest().then(res => {
      this.value = res;
      this.loading = false;
    });
  }

  createApiRequest() {
    return new Promise((resolve, reject) => {
      let url = this.apiUrl;

      const configs: IRequestConfig = getConfigs(
        this.apiMethod,
        "application/json",
        url,
        {}
      );
      const yearOption: any = {};
      yearOption[this.apiParamNameYear] = this.year;
      configs.params = Object.assign({}, yearOption, this.apiParameters);
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
